import React from 'react';
import './LoaderTriangles.css';

export const LoaderTriangles: React.FC = () => {
  return (
    <div className="loader-fixed-center">
      <svg
        className="loader-two-triangles"
        viewBox="0 0 30 36"
        width="96"
        height="96"
      >
        <polygon className="tri tri-left" points="0,20 10,3 20,20" />
        <polygon className="tri tri-right" points="20,20 25,29 30,20" />
      </svg>
    </div>
  );
};
